import { Component, inject } from '@angular/core';
import { LucideRefreshCw, LucideX } from '@lucide/angular';

import { ActualizacionService } from '../../../core/services/actualizacion.service';

/**
 * Aviso de versión nueva.
 *
 * A propósito NO es un diálogo modal: el operador puede estar a mitad de un
 * escaneo y bloquearlo con una ventana sería peor que esperar. El aviso se queda
 * abajo y él decide cuándo recargar.
 */
@Component({
  selector: 'app-actualizacion-banner',
  imports: [LucideRefreshCw, LucideX],
  template: `
    @if (servicio.disponible()) {
      <div
        role="status"
        class="fixed bottom-4 left-1/2 z-50 w-[calc(100%-2rem)] max-w-md -translate-x-1/2
               rounded-xl border border-slate-200 bg-white p-4 shadow-lg"
      >
        <div class="flex items-start gap-3">
          <span
            class="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center
                   rounded-lg bg-blue-50 text-blue-600"
          >
            <svg lucideRefreshCw [size]="16"></svg>
          </span>

          <div class="min-w-0 flex-1">
            <p class="text-sm font-semibold text-slate-900">Nueva versión disponible</p>
            <p class="mt-0.5 text-xs text-slate-500">Recarga para usar la versión más reciente.</p>

            <div class="mt-3 flex items-center gap-2">
              <button
                type="button"
                (click)="servicio.actualizar()"
                [disabled]="servicio.activando()"
                class="inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-3 py-1.5
                       text-xs font-semibold text-white transition hover:bg-blue-700
                       disabled:cursor-not-allowed disabled:opacity-60"
              >
                @if (servicio.activando()) {
                  <svg lucideRefreshCw [size]="13" class="animate-spin"></svg>
                  Actualizando...
                } @else {
                  Actualizar
                }
              </button>
              <button
                type="button"
                (click)="servicio.descartar()"
                class="rounded-lg px-3 py-1.5 text-xs font-medium text-slate-500
                       transition hover:bg-slate-50 hover:text-slate-700"
              >
                Después
              </button>
            </div>
          </div>

          <button
            type="button"
            (click)="servicio.descartar()"
            aria-label="Descartar"
            class="-mr-1 -mt-1 rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-50"
          >
            <svg lucideX [size]="15"></svg>
          </button>
        </div>
      </div>
    }
  `,
})
export class ActualizacionBannerComponent {
  protected readonly servicio = inject(ActualizacionService);
}
